// Б.2.d: ИИ-модель без цензуры — EOT-триггер.
//
// В конце КАЖДОГО ХОДА (после Ф5) ИИ-модель наносит 1 урон ВСЕМ персонажам
// противника: всем вражеским юнитам и вражескому Герою.
//
// Эпическая → Режим ожидания. Спящая ИИ-модель не триггерится.
// Каждый удар может вызвать смерть и Посмертия (стандартный каскад).
// Если на стороне врага нет юнитов — бьёт только Героя.

import { applyDamage } from '../../combat.js';
import { applyHeroDamage } from '../../hero-damage.js';
import { dispatchUnitDied } from '../deus/hooks.js';
import { shortHeroName } from '../../../data/heroes.js';
import { notifyCharacterDamaged } from './temnyy-netranner.js';

export const CARD_ID = 'syn_ii_model_bez_tsenzury';

export function iiModelEot(state, ownerIdx, modelUnit) {
  if (!modelUnit.isAlive()) return;
  if (modelUnit.isSleeping(state.currentTurn)) return;
  const enemyIdx = 1 - ownerIdx;
  const enemy = state.players[enemyIdx];
  const ownerName = state.players[ownerIdx].name;
  state.log.add(`🤖 ${modelUnit.name_ru} [${ownerName}]: 1 урон всем персонажам противника`);

  // Снимок вражеских юнитов — урон может убить, не сдвигая итерацию.
  const targets = [...enemy.unitsOnField()];
  for (const target of targets) {
    if (!target.isAlive()) continue;
    const before = { hp: target.hp, armor: target.armor };
    const r = applyDamage(target, 1, { pierce: false });
    state.log.add(
      `  → ${target.name_ru} [${enemy.name}]: 1 урона ` +
      `(HP ${before.hp}→${target.hp}, броня ${before.armor}→${target.armor})`
    );
    const taken = (r.armorAbsorbed || 0) + (r.hpLost || 0);
    if (taken > 0) notifyCharacterDamaged(state, enemyIdx, target, taken);
    if (target.hp <= 0) {
      enemy.removeFromField(target);
      state.log.add(`✗ ${target.name_ru} [${enemy.name}] погибает`);
      dispatchUnitDied(state, {
        ownerIdx: enemyIdx, card: target,
        killer: modelUnit, killerIdx: ownerIdx, killerWasCounter: false
      });
    }
  }
  // Удар по Герою (Иммунитет/Парашют учитываются applyHeroDamage).
  if (enemy.hero.hp > 0) {
    state.log.add(`  → ${shortHeroName(enemy.hero)} [${enemy.name}]: 1 урона`);
    applyHeroDamage(state, enemyIdx, 1, { pierce: false });
  }
}
